module.exports = __webpack_public_path__ + "img/logo-kermanmotor-w.c1f0259.png";